import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideJobsProps {
    onClose: () => void;
}

export const HelpGuideJobs = ({ onClose }: HelpGuideJobsProps) => {
    return (
        <div>
            <ModalHeader
                title="Jobs"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The Jobs feature helps you manage your saved job postings
                    and tailor your resume for specific positions.
                </AppText>

                <div className="mb-2">
                    <h4 className="font-semibold">Key Features:</h4>
                    <ul className="ml-4 list-disc">
                        <li>
                            <AppText variant="regular">
                                View and manage your created and saved jobs
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Attach a job to your resume for targeted
                                tailoring
                            </AppText>
                        </li>
                        <li>
                            <AppText variant="regular">
                                Tailor your resume using the Smart Match feature
                            </AppText>
                        </li>
                    </ul>
                </div>

                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    When you attach a job to your resume, you can tailor it by
                    either updating the existing resume or creating a new
                    tailored version. This ensures your resume is as relevant as
                    possible for each specific position.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    The Smart Match Tailor Resume feature allows you to quickly
                    create job-tailored resumes without the hassle, making your
                    application process more efficient and effective.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
